import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-12 text-center" data-id="element-58">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-59">
        <p className="mb-4" data-id="element-60">
          © {new Date().getFullYear()} Mega Library Pack. Todos los derechos
          reservados.
        </p>
        <p className="text-sm text-gray-500 max-w-2xl mx-auto" data-id="element-61">
          Este sitio no forma parte del sitio web de Facebook ni de Facebook
          Inc. Además, este sitio NO está respaldado por Facebook de ninguna
          manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}